import { REIMBURSEMENT_STEP_IDS, type ReimbursementStep, type ReimbursementStepId } from './types';

const LABEL_KEYS: Record<ReimbursementStepId, string> = {
    terms: 'REIMBURSEMENT.STEPS.TERMS',
    reason: 'REIMBURSEMENT.STEPS.REASON',
    details: 'REIMBURSEMENT.STEPS.DETAILS',
};

export const REIMBURSEMENT_STEPS: ReadonlyArray<ReimbursementStep> = REIMBURSEMENT_STEP_IDS.map((id) => ({
    id,
    labelKey: LABEL_KEYS[id],
}));

export function isReimbursementStepId(value: string): value is ReimbursementStepId {
    return (REIMBURSEMENT_STEP_IDS as ReadonlyArray<string>).includes(value);
}

export function getStepIndex(id: ReimbursementStepId): number {
    return REIMBURSEMENT_STEPS.findIndex((step) => step.id === id);
}

export function getNextStep(id: ReimbursementStepId): ReimbursementStep | undefined {
    return REIMBURSEMENT_STEPS[getStepIndex(id) + 1];
}

export function getPreviousStep(id: ReimbursementStepId): ReimbursementStep | undefined {
    const index = getStepIndex(id);
    return index > 0 ? REIMBURSEMENT_STEPS[index - 1] : undefined;
}

export function isLastStep(id: ReimbursementStepId): boolean {
    return getStepIndex(id) === REIMBURSEMENT_STEPS.length - 1;
}
